/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component, { ComponentAttrs } from 'flarum/common/Component';
import type Mithril from 'mithril';
import type Article from '../models/Article';
import ArticleListItem from './ArticleListItem';

export interface ArticleListContentAttrs extends ComponentAttrs {
	articles: Article[];
	searchQuery?: string;
	loadMore?: Mithril.Children;
	onSelect?: (article: Article) => void;
	selectedArticles?: Article[];
	multiSelectable?: boolean;
}

export default class ArticleListContent extends Component<ArticleListContentAttrs> {
	view() {
		const { articles, searchQuery, loadMore, onSelect, selectedArticles, multiSelectable } = this.attrs;

		return (
			<div className="ArticleList">
				<ul className="ArticleList-articles">
					{articles.map((article) => (
						<ArticleListItem
							article={article}
							searchQuery={searchQuery}
							onSelect={onSelect}
							selected={ArticleListContent.isArticleSelected(selectedArticles, article)}
							multiSelectable={multiSelectable}
						/>
					))}
				</ul>
				<div className="ArticleList-loadMore">{loadMore}</div>
			</div>
		);
	}

	static isArticleSelected(selectedArticles: Article[] = [], article: Article): boolean {
		return selectedArticles.some((_article) => _article.ean() === article.ean());
	}
}
